"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getLanguageByName = exports.getLanguageByName = function getLanguageByName() {
  var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments[1];

  if (!name) {
    return;
  }
  var choices = languages.filter(function (language) {
    return language.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  return choices.length ? choices[0] : null;
};

var getInsurerByName = exports.getInsurerByName = function getInsurerByName() {
  var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments[1];

  if (!name) {
    return;
  }
  var choices = insurers.filter(function (insurer) {
    return insurer.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  return choices.length ? choices[0] : null;
};

var getTreatmentGroupByName = exports.getTreatmentGroupByName = function getTreatmentGroupByName() {
  var treatmentGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments[1];

  if (!name || !name.length) {
    return null;
  }
  var choices = treatmentGroups.filter(function (treatmentGroup) {
    return treatmentGroup.treatments;
  }).reduce(function (treatmentGroups, treatmentGroup) {
    return [].concat(_toConsumableArray(treatmentGroups), _toConsumableArray(treatmentGroup.treatments));
  }, []).filter(function (treatment) {
    return treatment.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  return choices.length ? choices[0] : null;
};

var getConditionByName = exports.getConditionByName = function getConditionByName() {
  var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments[1];

  if (!name) {
    return;
  }
  var choices = conditions.filter(function (condition) {
    return condition.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  return choices.length ? choices[0] : null;
};

var getProcedureByName = exports.getProcedureByName = function getProcedureByName() {
  var procedures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments[1];

  if (!name) {
    return;
  }
  var choices = procedures.filter(function (procedure) {
    return procedure.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  return choices.length ? choices[0] : null;
};

var getHealthCheckByName = exports.getHealthCheckByName = function getHealthCheckByName() {
  var healthChecks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments[1];

  if (!name) {
    return;
  }
  var choices = healthChecks.filter(function (healthCheck) {
    return healthCheck.name.trim().toLowerCase() === name.trim().toLowerCase();
  });
  return choices.length ? choices[0] : null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/listing-mapping.js
// module id = 1529
// module chunks = 0